import { useEffect, useState } from "react";
import DesktopSidebar from "../Home/Sidebars/DesktopSidebar";
import { useSelector } from "react-redux";
import { FaFacebook, FaWhatsapp, FaXTwitter } from "react-icons/fa6";
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import FormControl from "../../common/FormControl";
import methodModel from "../../methods/methods";
import ApiClient from "../../methods/api/apiClient";
import Pagination from "react-js-pagination";
import moment from "moment";
import SelectDropdown from "../../common/SelectDropdown";
import loader from "../../methods/loader";
import { useNavigate } from "react-router-dom";

const Referral = () => {
    const navigate = useNavigate()
    const user = useSelector((state) => state.user)
    const currentDomain = window.location.host
    const title = "Kindly use the following URL to complete the signup process on Marc."
    const referralCodeUrl = `${currentDomain}/providersignup?code=${user?.referCode || ""}`
    const [email, setEmail] = useState("")
    const [submitted, setSubmitted] = useState({ value: false, copy: false, invite: false })
    const inValidEmail = methodModel.emailvalidation(email);
    const [filter, setFilter] = useState({ page: 1, count: 10, status: "" })
    const [total, setTotal] = useState(0)
    const [history, setHistory] = useState([])
    const [walletDetail, setWalletDetail] = useState()

    useEffect(() => {
        getWalletDetail()
        getReferralHistory()
    }, [])

    const getWalletDetail = () => {
        loader(true)
        ApiClient.get(`wallet/get?userId=${user?._id || user?.id}`).then(res => {
            if (res.success) {
                setWalletDetail(res?.data)
            }
            loader(false)
        })
    }

    const getReferralHistory = (f = {}) => {
        const params = { ...filter, ...f, userId: user?._id || user?.id }
        loader(true)
        ApiClient.get(`refer/listing`, params).then(res => {
            if (res.success) {
                setHistory(res?.data)
                setTotal(res?.total)
            }
            loader(false)
        })
    }

    const copyReferralCodeUrl = () => {
        navigator.clipboard.writeText(referralCodeUrl);
        setSubmitted((prev) => ({ ...prev, copy: true }))
        setTimeout(() => {
            setSubmitted((prev) => ({ ...prev, copy: false }))
        }, 1000);
    };

    const handleInvite = (e) => {
        e.preventDefault()
        setSubmitted((prev) => ({ ...prev, value: true }))
        if (!inValidEmail) return
        const payload = { email: email, referCode: user?.referCode || "" }
        ApiClient.post(`refer/send/invite`, payload).then(res => {
            if (res.success) {
                getReferralHistory()
                setSubmitted((prev) => ({ ...prev, value: false, invite: true }))
                setTimeout(() => {
                    setSubmitted((prev) => ({ ...prev, value: false, invite: false }))
                }, 2000);
                setEmail("")
            }
        })
    }

    const handlePagination = (e) => {
        setFilter((prev) => ({ ...prev, page: e }))
        getReferralHistory({ page: e })
    }

    const handleFilters = (e, key) => {
        setFilter({ ...filter, [key]: e, page: 1 });
        getReferralHistory({ [key]: e, page: 1 });
    }

    const clear = () => {
        let f = { status: "", page: 1 }
        setFilter({ ...filter, ...f });
        getReferralHistory({ ...f });
    }

    return (
        <div className="bg-white w-full h-screen">
            <DesktopSidebar />
            <div className="container mx-auto px-5 pt-6 pb-5">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                    {user?.role === "member" &&
                        <div className="border-[1px] rounded-[15px] p-5">
                            <div class="mb-6">
                                <h2 className="text-xl font-semibold text-[#134896]">My Wallet</h2>
                                <p class="text-gray-500">Funds may only be used for the purchase of tickets.</p>
                            </div>
                            <div class="grid grid-cols-1 gap-3">
                                <div class="flex justify-between gap-3 items-center bg-[#11a15314] px-5 py-3 rounded-lg">
                                    <h3 class="text-lg font-semibold text-gray-800 leading-[22px]">Lifetime Earnings</h3>
                                    <div class="text-right">
                                        <p class="text-2xl font-bold text-green-600">${parseFloat(walletDetail?.lifeTimePoints || 0).toFixed(2)}</p>
                                    </div>
                                </div>
                                <div class="flex justify-between gap-3 items-center bg-[#06368812] px-5 py-3 rounded-lg">
                                    <h3 class="text-lg font-semibold text-gray-800 leading-[22px]">Available Balance</h3>
                                    <div class="text-right">
                                        <p class="text-2xl font-bold text-[#134896]">${parseFloat(walletDetail?.points || 0).toFixed(2)}</p>
                                    </div>
                                </div>
                            </div>
                            <p className="text-gray-500 mt-3">If the referred subscriber cancels their account within 14 days, the referrer’s credits will be revoked. To qualify for the referral bonus, the referred subscriber must remain active and in good standing for a minimum of 30 days. Unused credits will expire 90 days from the date they are earned.</p>
                            <div class="flex justify-end mt-3"><button type="button" onClick={() => { navigate(`/Event`) }} class="bg-[#063688] text-white px-4 py-2 rounded-md hover:opacity-[90%]">Purchase Tickets</button></div>
                        </div>
                    }
                    <div className="border-[1px] rounded-[15px] p-5">
                        <div className="">
                            <h2 className="text-xl font-semibold mb-3 text-[#134896]">Share Referral Link</h2>
                            <div className="">
                                {user?.role === "member" ?
                                    <label className="text-sm">Once user sign up via your link you will receive a $0.50 store credit, up to a maximum of 5 referrals.</label>
                                    :
                                    <label className="text-sm">Once user sign up via your link you will get a free month of the Elite plan.</label>
                                }
                                <div className="mt-2">
                                    <div className="flex items-center">
                                        <input type="text" readOnly className="border border-[#d1d1d1] h-10 text-gray-900 text-sm rounded-l-md block w-full ps-3 p-2.5" value={referralCodeUrl} />
                                        <button type="button" onClick={() => copyReferralCodeUrl()} className="bg-[#063688] text-white h-10 px-4 py-2 rounded-r-md min-w-[80px] hover:opacity-[90%]">{submitted?.copy ? "Copied" : "Copy"}</button>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5">
                                <label className="text-sm">Or share directly via these buttons:</label>
                                <div className="flex flex-wrap gap-2 mt-2">
                                    <WhatsappShareButton url={referralCodeUrl} title={title} separator=":: ">
                                        <div className={`bg-[#25d366] p-2 text-white rounded-md flex items-center gap-1 hover:opacity-[90%]`}>
                                            <FaWhatsapp className="text-[20px]" />
                                            <span>Whatsapp</span>
                                        </div>
                                    </WhatsappShareButton>
                                    <FacebookShareButton url={referralCodeUrl} quote={title}>
                                        <div className={`bg-[#4267B2] p-2 text-white rounded-md flex items-center gap-1 hover:opacity-[90%]`}>
                                            <FaFacebook className="text-[20px]" />
                                            <span>Facebook</span>
                                        </div>
                                    </FacebookShareButton>
                                    <TwitterShareButton url={referralCodeUrl} title={title}>
                                        <div className={`bg-[#14171a] p-2 text-white rounded-md flex items-center gap-1 hover:opacity-[90%]`}>
                                            <FaXTwitter className="text-[20px]" />
                                            <span>Twitter</span>
                                        </div>
                                    </TwitterShareButton>
                                </div>
                            </div>
                        </div>
                        <div className="mt-8">
                            <h2 className="text-xl font-semibold mb-3 text-[#134896]">Invite User</h2>
                            <form onSubmit={handleInvite}>
                                <div className="my-2">
                                    <FormControl
                                        type="text"
                                        name="email"
                                        label="Email"
                                        placeholder="Enter Email"
                                        autoComplete="one-time-code"
                                        value={email}
                                        onChange={(e) => setEmail(e)}
                                        required
                                    />
                                    {email && !inValidEmail && submitted?.value && (
                                        <div className="d-block text-sm text-red-600">Please enter valid email</div>
                                    )}
                                    {submitted?.invite && <p className="text-green-600">The user has been successfully invited.</p>}
                                </div>
                                <div className="flex justify-end mt-3">
                                    <button type="submit" className="bg-[#063688] text-white px-4 py-2 rounded-md hover:opacity-[90%]">Invite</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="border-[1px] rounded-[15px] p-5 mt-5">
                    <div className="flex flex-wrap gap-x-5 gap-3 justify-between mb-3">
                        <h2 className="text-xl font-semibold text-[#134896]">Invite History</h2>
                        <div className="flex gap-2 ml-auto flex-wrap justify-end max-[499px]:w-full ml-auto">
                            <SelectDropdown
                                id="statusDropdown"
                                displayValue="name"
                                placeholder="All Status"
                                className="capitalize max-[499px]:w-full"
                                theme="search"
                                isClearable={false}
                                intialValue={filter?.status}
                                result={(e) => { handleFilters(e.value, "status") }}
                                options={[
                                    { id: "pending", name: "Pending" },
                                    { id: "verified", name: "Success" },
                                ]}
                            />
                            {filter?.status ? (
                                <button onClick={() => clear()} className="bg-[#134896] leading-10 h-10 inline-block shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-full">
                                    Reset
                                </button>
                            ) : null}
                        </div>
                    </div>
                    <div className="relative table-responsive overflow-x-auto border border-[#eee] sm:rounded-lg ">
                        <table className="table w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 capitalize bg-gray-50 ">
                                <tr className="border-b border-[#cacaca]">
                                    <th className="px-3 py-3"><span className="whitespace-nowrap">Date</span></th>
                                    <th className="px-3 py-3"><span className="whitespace-nowrap">Email</span></th>
                                    <th className="px-3 py-3"><span className="whitespace-nowrap">Role</span></th>
                                    <th className="px-3 py-3"><span className="whitespace-nowrap">Status</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {history?.map((item, index) => {
                                    return <tr className="bg-white border-b hover:bg-gray-50" key={index}>
                                        <td className="px-3 py-4 whitespace-nowrap">{moment(item?.createdAt).format("DD MMM, YYYY hh:mm A")}</td>
                                        <td className="px-3 py-4 whitespace-nowrap">{item?.referedTo}</td>
                                        <td className="px-3 py-4 whitespace-nowrap capitalize">{item?.referedToId?.role}</td>
                                        <td className={`px-3 py-4 whitespace-nowrap capitalize ${item?.status === "verified" ? "text-green-600" : "text-yellow-600"}`}>{item?.status}</td>
                                    </tr>
                                })}
                                {history?.length === 0 &&
                                    <tr className="bg-white border-b hover:bg-gray-50">
                                        <td colspan="4" className="p-4 text-sm text-gray-800 text-center">User not invited yet</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                        {total > filter?.count ?
                            <div className="pagination_div w-[100%] text-right mx-auto">
                                <Pagination
                                    activePage={filter?.page}
                                    itemsCountPerPage={filter?.count}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    hideFirstLastPages
                                    prevPageText="Previous"
                                    nextPageText="Next"
                                    itemClass="bg-white px-2 text-[#8f8f8f] rounded-md"
                                    activeClass="!bg-[#005AAB] px-2 !text-white rounded-md"
                                    onChange={e => handlePagination(e)}
                                />
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Referral